import { getFramework } from '@/framework';
import { getLocaleStore } from '@/i18n';
import type { IRenderContextMenuItemArgs } from '@/plugins/context-menu/type';
import { LayerHotkeyType } from '../../type';

export const layerDeleteItem = ({ activeLayer, pickLayer }: IRenderContextMenuItemArgs, identity: string) => {
    const { $t } = getLocaleStore();
    const framework = getFramework(identity);
    const layer = pickLayer || activeLayer;

    if (!layer) return null;

    let disabled = false;
    if (pickLayer) {
        disabled = !framework.service.flatLayer.checkPossibleDelete(pickLayer);
    }

    const type = LayerHotkeyType.DELETE;
    const item = {
        disabled,
        name: $t((v) => v.contextMenuLayer.menuConfig.delete),
        type,
        desc: framework.service.hotkey.getDesc(type),
        onClick: () => {
            framework.service.hotkey.__emitDelete({ from: 'context-menu' });
        },
    };

    return item;
};
